 
 
const jsUrlLookup = {
    CliqbookXA: () => typeof loadAgentTool == 'function' && loadAgentTool('/AgentTool-XA/agenttool.asp'),
    OpenAgent: () => typeof loadAgentTool == 'function' && loadAgentTool('/AgentTool-OpenAgent/agenttool.asp'),
    Processor: () => {
        if (CNQR && CNQR.currentPage && (CNQR.currentPage == 'processor') && CNQR.processor && CNQR.processor.MenuLinkClicked) { CNQR.processor.MenuLinkClicked(); } else { document.location.href = '/Expense/Client/processor.asp?RptListFilter=processor'; }
    },
    AuthReqViewRequests: () => {
        if (CNQR && CNQR.authr && CNQR.authr.viewMyAuthRequests) { CNQR.authr.viewMyAuthRequests(); } else { document.location.href = '/expense/Client/authorizations.asp?action=requests'; }
    },
    AuthReqNewRequest: () => {
        if (CNQR && CNQR.authr && CNQR.authr.addNewAuthorizationRequest) { CNQR.authr.addNewAuthorizationRequest(); } else { document.location.href = '/expense/Client/authorizations.asp?action=new'; }
    },
    AuthReqProcessRequests: () => {
        if (CNQR && CNQR.currentPage && (CNQR.currentPage == 'authorizations') && CNQR.processor && CNQR.processor.MenuLinkClicked) { CNQR.processor.MenuLinkClicked(); } else { document.location.href = '/Expense/Client/authorizations.asp?action=processor'; }
    },
    CVP_MyRequests: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewMyRequests) { CNQR.cvp.viewMyRequests(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=invoiceNUIUnavailable'); }
    },
    CVP_AssignRequests: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewAssignRequests) { CNQR.cvp.viewAssignRequests(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=invoiceNUIUnavailable'); }
    },
    CVP_PurchasingRequests: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewPurchasingRequests) { CNQR.cvp.viewPurchasingRequests(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=purchasing'); }
    },
    CVP_DeletedRequests: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewDeletedRequests) { CNQR.cvp.viewDeletedRequests(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=delete'); }
    },
    CVP_ProcessImages: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewProcessImages) { CNQR.cvp.viewProcessImages(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=images'); }
    },
    CVP_InvoiceCapture: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewICEmailProcessing) { CNQR.cvp.viewICEmailProcessing(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=icEmailProcessing'); }
    },
    CVP_PaymentManager: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewPaymentManager) { CNQR.cvp.viewPaymentManager(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=paymentManager'); }
    },
    CVP_VendorManagement: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewVendorMgmt) { CNQR.cvp.viewVendorMgmt(); } else { window.location.assign('/Expense/Payables/CVP_Portal.asp?action=vendorMgmt'); }
    },
    ReqProcessRequests: () => {
        if (window.CNQR && CNQR.pages && CNQR.pages.openPage) {
            CNQR.pages.openPage({ params: 'mode=toprocess', url: '/Expense/Request/default.asp?mode=toprocess' });
        } else { document.location.href = '/Expense/Request/default.asp?mode=toprocess'; }
    },
    PurReq_RequestItems: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewRequestItems) { CNQR.purch.viewRequestItems(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?action=items'; }
    },
    PurReq_MyOrders: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewProcessOrders) { CNQR.purch.viewProcessOrders(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?action=orders'; }
    },
    PurReq_ProcessRequestsLong: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewProcessRequests) { CNQR.purch.viewProcessRequests(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?action=process'; }
    },
    PurReq_OrdersLong: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewProcessOrders) { CNQR.purch.viewProcessOrders(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?action=orders'; }
    },
    PurReq_Extracts: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewProcessOrderExtracts) { CNQR.purch.viewProcessOrderExtracts(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?action=extracts'; }
    },
    PurReq_AllOrders: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewProcessOrders) { CNQR.purch.viewProcessOrders(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?action=orders'; }
    },
    ApprovalsExpense: () => {
        if (CNQR && CNQR.currentPage && (CNQR.currentPage == 'expense') && CNQR.expense && CNQR.expense.viewMgrReportsToApprove) { CNQR.expense.viewMgrReportsToApprove(); } else { document.location.href = '/Expense/Client/default.asp?gateway=1&RptListFilter=toapprove'; }
    },
    Authorizations: () => {
        if (CNQR && CNQR.authr && CNQR.authr.viewAuthRequestsToApprove) { CNQR.authr.viewAuthRequestsToApprove(); } else { document.location.href = '/expense/Client/authorizations.asp?action=toapprove'; }
    },
    CashAdvances: () => {
        if (CNQR && CNQR.currentPage && (CNQR.currentPage == 'expense') && CNQR.expense && CNQR.expense.approveCashAdvances) { CNQR.expense.approveCashAdvances(); } else { document.location.href = '/expense/Client/default.asp?gateway=1&cashadvance=approve'; }
    },
    PurchaseRequests: () => {
        if (CNQR && CNQR.purch && CNQR.purch.viewApproveRequests) { CNQR.purch.viewApproveRequests(); } else { document.location.href = '/Expense/PurchaseRequest/PurchReq_Portal.asp?gateway=1&action=approve'; }
    },
    PaymentRequests: () => {
        if (CNQR && CNQR.cvp && CNQR.cvp.viewApproveRequests) { CNQR.cvp.viewApproveRequests(); } else { document.location.href = '/Expense/Payables/CVP_Portal.asp?gateway=1&action=approve'; }
    },
    LocalizationMode: () => typeof changeLocalizationMode == 'function' && changeLocalizationMode(),
    CVP_CreateNewRequest_NUI: () => {
        if (window.sessionStorage.getItem('ALLOW_REIMAGINED_UI') === 'true') { document.location.href = '/nui/invoice/create-invoice'; } else if (window.sessionStorage.getItem('ALLOW_NEXTGEN') === 'Active') { document.location.href = '/nui/invoice/upload'; } else { document.location.href = '/Expense/Payables/CVP_Portal.asp?action=new'; }
    },
};

// Links that share the current page's path and query but differ only by the URL
// fragment are treated by the browser as a same-document navigation and do NOT
// reload. Pages that render their content from the fragment on load (e.g. the
// Standard Setup Wizard, brkSetupWizard.asp) therefore never switch sections
// when reached from the merged SideNav. Force a reload in that case so the
// requested section renders, matching the first-navigation behaviour.
const createSamePageHashNavHandler = (url) => (event) => {
    let target;
    try {
        target = new URL(url, window.location.href);
    } catch {
        return;
    }
    const { location } = window;
    // Only a real section fragment (#page_x) — not a bare "#" placeholder or an
    // empty fragment — should trigger the reload.
    const hasSectionFragment = target.hash !== '' && target.hash !== '#';
    const isSamePageSectionChange = target.pathname === location.pathname
        && target.search === location.search
        && hasSectionFragment
        && target.hash !== location.hash;
    if (isSamePageSectionChange) {
        event.preventDefault();
        location.hash = target.hash;
        location.reload();
    }
};

const convertJavascriptUrl = (url, id) => {
    if (!url) return {};

    if (url.startsWith('javascript:')) {
        return jsUrlLookup[id] ? { onClick: jsUrlLookup[id] } : { href: url };
    }

    return {
        href: url,
        onClick: createSamePageHashNavHandler(url),
    };
};

export default convertJavascriptUrl;
